import { useDispatch, useSelector } from "react-redux";

import { setSidebarToggleMobile } from "features/sidebarSlice";
import HeaderSearch from "layoutComponents/HeaderSearch";
import HeaderUserbox from "layoutComponents/HeaderUserbox";
import { PATHS_WITH_SEARCH } from "constants/pathnames";

import clsx from "clsx";
import { usePathPattern } from "hooks/useCurrentPath";

const Header = () => {
  const { headerShadow, headerBgTransparent } = useSelector(
    (state) => state.header,
  );
  const { sidebarToggleMobile } = useSelector((state) => state.sidebar);

  const user = useSelector((state) => state.auth.userData);

  const dispatch = useDispatch();
  const pathPattern = usePathPattern();

  const hasSearch =
    pathPattern !== null &&
    PATHS_WITH_SEARCH &&
    Array.isArray(PATHS_WITH_SEARCH) &&
    PATHS_WITH_SEARCH.includes(pathPattern);

  const toggleSidebarMobile = () => {
    dispatch(setSidebarToggleMobile(!sidebarToggleMobile));
  };

  return (
    <>
      <div
        className={clsx("app-header", {
          "app-header--shadow": headerShadow,
          "app-header--opacity-bg": headerBgTransparent,
        })}
      >
        <div
          style={{
            width: "100%",
          }}
          className="app-header--pane w100"
        >
          <button
            className={clsx(
              "navbar-toggler hamburger hamburger--elastic toggle-mobile-sidebar-btn",
              { "is-active": sidebarToggleMobile },
            )}
            onClick={toggleSidebarMobile}
          >
            <span className="hamburger-box">
              <span className="hamburger-inner" />
            </span>
          </button>
          {hasSearch && <HeaderSearch />}
          <div
            style={{
              marginLeft: "auto",
            }}
            className="text-center d-flex align-items-center"
          >
            <p className="user_name m-0 p-0">{user?.name}</p>
            <HeaderUserbox />
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
